import React, { Component } from "react";
import CartContext from "./CartContext";
import {
  Table,
  Button,
  Modal,
  Form,
  Spinner,
  Alert,
  Row,
  Col,
} from "react-bootstrap";
import axios from "axios";

export default class EmployeeAbsence extends Component {
  static contextType = CartContext;

  constructor(props) {
    super(props);
    this.state = {
      absences: [],
      employees: [],
      showModal: false,
      isEdit: false,
      loading: false,
      error: "",
      filters: {
        employeeId: "",
        dateRange: "all", // all | week | month | year | custom
        from: "",
        to: "",
      },
      form: {
        id: "",
        employeeId: "",
        startDate: "", // stored in DB
        totalDays: 1, // optional, user-entered
        reasons: "",
        leaveType: 1,
      },
    };
  }

  componentDidMount() {
    this.fetchAbsences();
    this.fetchEmployees();
    window.scrollTo(0, 0);
  }

  fetchAbsences = async () => {
    const storeId = this.context.storeId;
    if (!storeId) {
      this.setState({ error: "storeId is required", loading: false });
      return;
    }

    this.setState({ loading: true, error: "" });

    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API}EmployeeAbsence/EmployeeAbsence/${storeId}`
        // `${process.env.REACT_APP_API}EmployeeAbsence`
      );
      this.setState({ absences: res.data, loading: false });
    } catch (err) {
      this.setState({
        error: "Failed to load absences.",
        loading: false,
      });
    }
  };

  fetchEmployees = () => {
    axios
      .get(
        process.env.REACT_APP_API +
          "Employee/GetEmployees/" +
          this.context.storeId
      )
      .then((res) => this.setState({ employees: res.data }))
      .catch(() => this.setState({ error: "Failed to load employees." }));
  };

  handleChange = (e) => {
    this.setState({
      form: { ...this.state.form, [e.target.name]: e.target.value },
    });
  };

  handleFilterChange = (e) => {
    this.setState({
      filters: { ...this.state.filters, [e.target.name]: e.target.value },
    });
  };

  resetForm = () => ({
    id: "",
    employeeId: "",
    date: "",
    reasons: "",
    leaveType: 1,
  });

  openModal = (absence = null) => {
    if (absence) {
      this.setState({
        form: {
          ...absence,
          date: absence.date ? absence.date.split("T")[0] : "",
        },
        isEdit: true,
        showModal: true,
      });
    } else {
      this.setState({
        form: this.resetForm(),
        isEdit: false,
        showModal: true,
      });
    }
  };

  closeModal = () => this.setState({ showModal: false });

  saveAbsence = async () => {
    const { form, isEdit } = this.state;

    if (!form.employeeId || !form.startDate) {
      alert("Employee and Date are required!");
      return;
    }

    const totalDays = form.totalDays && form.totalDays > 0 ? form.totalDays : 1;

    this.setState({ saving: true });

    try {
      const requests = [];

      for (let i = 0; i < totalDays; i++) {
        const date = new Date(form.startDate);
        date.setDate(date.getDate() + i);

        const payload = {
          storeId: this.context.storeId,
          employeeId: form.employeeId,
          date: date.toISOString().split("T")[0], // only startDate stored
          reasons: form.reasons,
          leaveType: Number(form.leaveType),
        };

        if (isEdit) {
          // only update the first day if editing
          if (i === 0) {
            requests.push(
              axios.put(
                process.env.REACT_APP_API + `EmployeeAbsence/${form.id}`,
                payload
              )
            );
          }
        } else {
          requests.push(
            axios.post(process.env.REACT_APP_API + "EmployeeAbsence", payload)
          );
        }
      }

      await Promise.all(requests); // send all requests in parallel

      this.fetchAbsences();
      this.closeModal();
    } catch (error) {
      console.error("Save error:", error);
      const msg =
        error.response?.data?.message ||
        error.response?.data ||
        "Failed to save absence. Try again.";
      alert(msg);
    } finally {
      this.setState({ saving: false });
    }
  };

  deleteAbsence = (id) => {
    if (window.confirm("Are you sure you want to delete this absence?")) {
      axios
        .delete(process.env.REACT_APP_API + `EmployeeAbsence/${id}`)
        .then(() => this.fetchAbsences())
        .catch(() => alert("Failed to delete absence"));
    }
  };

  getEmployeeName = (id) => {
    const emp = this.state.employees.find((e) => e.id === id);
    return emp ? `${emp.firstName} ${emp.lastName || ""}` : id;
  };

  filterAbsences = () => {
    const { absences, filters } = this.state;
    let result = [...absences];

    // Employee filter
    if (filters.employeeId) {
      result = result.filter((a) => a.employeeId === filters.employeeId);
    }

    // Date filter
    if (filters.dateRange !== "all") {
      const now = new Date();
      result = result.filter((a) => {
        const d = new Date(a.date);
        if (filters.dateRange === "week") {
          const start = new Date();
          start.setDate(now.getDate() - now.getDay());
          const end = new Date(start);
          end.setDate(start.getDate() + 7);
          return d >= start && d < end;
        } else if (filters.dateRange === "month") {
          return (
            d.getMonth() === now.getMonth() &&
            d.getFullYear() === now.getFullYear()
          );
        } else if (filters.dateRange === "year") {
          return d.getFullYear() === now.getFullYear();
        } else if (filters.dateRange === "custom") {
          if (filters.from && filters.to) {
            return d >= new Date(filters.from) && d <= new Date(filters.to);
          }
        }
        return true;
      });
    }

    return result;
  };

  render() {
    const { employees, filters, showModal, form, isEdit, loading, error } =
      this.state;
    // const filteredAbsences = this.filterAbsences();
    const filteredAbsences = this.filterAbsences().sort((a, b) => {
      const dateA = new Date(a.date);
      const dateB = new Date(b.date);
      return dateA - dateB; // ascending order
    });

    return (
      <div className="container mt-1 ">
        <h3>
          <b>Employee Leave Management</b>
        </h3>

        {error && <Alert variant="danger">{error}</Alert>}

        {/* 🔹 Filters */}
        <Row className="mb-3 mt-2">
          <Col md={3} sm={6}>
            <Form.Select
              name="employeeId"
              value={filters.employeeId}
              onChange={this.handleFilterChange}
            >
              <option value="">All Employees</option>
              {employees.map((emp) => (
                <option key={emp.id} value={emp.id}>
                  {emp.firstName} {emp.lastName}
                </option>
              ))}
            </Form.Select>
          </Col>
          <Col md={3} sm={6}>
            <Form.Select
              name="dateRange"
              value={filters.dateRange}
              onChange={this.handleFilterChange}
            >
              <option value="all">All Dates</option>
              <option value="week">This Week</option>
              <option value="month">This Month</option>
              <option value="year">This Year</option>
              <option value="custom">Custom</option>
            </Form.Select>
          </Col>
          {filters.dateRange === "custom" && (
            <>
              <Col md={3} sm={6}>
                <Form.Control
                  type="date"
                  name="from"
                  value={filters.from}
                  onChange={this.handleFilterChange}
                />
              </Col>
              <Col md={3} sm={6}>
                <Form.Control
                  type="date"
                  name="to"
                  value={filters.to}
                  onChange={this.handleFilterChange}
                />
              </Col>
            </>
          )}
        </Row>

        <Button className="mb-2" onClick={() => this.openModal()}>
          + Add Leave
        </Button>

        {loading ? (
          <div className="text-center">
            <Spinner animation="border" />
          </div>
        ) : (
          <Table bordered responsive>
            <thead>
              <tr>
                <th>Employee</th>
                <th>Date</th>
                <th>Reasons</th>
                <th>Leave Type</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredAbsences
                .sort((a, b) => new Date(b.date) - new Date(a.date)) // sort by date descending
                .map((a) => (
                  <tr key={a.id}>
                    <td>{this.getEmployeeName(a.employeeId)}</td>
                    <td>
                      {a.date
                        ? new Date(a.date).toLocaleDateString("en-GB", {
                            day: "2-digit",
                            month: "short",
                            year: "numeric",
                          })
                        : ""}
                    </td>
                    <td>{a.reasons}</td>
                    <td>
                      {a.leaveType === 1 ? "Sick Leave" : "Personal Leave"}
                    </td>
                    <td>
                      <Button
                        variant="warning"
                        size="sm"
                        onClick={() => this.openModal(a)}
                      >
                        Edit
                      </Button>{" "}
                      <Button
                        variant="danger"
                        size="sm"
                        onClick={() => this.deleteAbsence(a.id)}
                      >
                        Delete
                      </Button>
                    </td>
                  </tr>
                ))}
            </tbody>
          </Table>
        )}

        {/* 🔹 Modal */}
        {/* 🔹 Modal */}
        <Modal show={showModal} onHide={this.closeModal}>
          <Modal.Header closeButton>
            <Modal.Title>{isEdit ? "Edit Absence" : "Add Absence"}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              {/* Employee */}
              <Form.Group className="mb-2">
                <Form.Label>Employee</Form.Label>
                <Form.Select
                  name="employeeId"
                  value={form.employeeId}
                  onChange={this.handleChange}
                >
                  <option value="">-- Select Employee --</option>
                  {employees.map((emp) => (
                    <option key={emp.id} value={emp.id}>
                      {emp.firstName} {emp.lastName}
                    </option>
                  ))}
                </Form.Select>
              </Form.Group>

              {/* Start Date */}
              <Form.Group className="mb-2">
                <Form.Label>Start Date</Form.Label>
                <Form.Control
                  type="date"
                  name="startDate"
                  value={form.startDate}
                  onChange={this.handleChange}
                />
              </Form.Group>

              {/* Total Days (UI-only) */}
              <Form.Group className="mb-2">
                <Form.Label>Total Days</Form.Label>
                <Form.Control
                  type="number"
                  name="totalDays"
                  value={form.totalDays || 1}
                  min={1}
                  onChange={this.handleChange}
                />
              </Form.Group>

              {/* End Date (calculated) */}
              <Form.Group className="mb-2">
                <Form.Label>End Date</Form.Label>
                <Form.Control
                  type="text"
                  readOnly
                  value={
                    form.startDate
                      ? new Date(
                          new Date(form.startDate).getTime() +
                            (form.totalDays - 1) * 24 * 60 * 60 * 1000
                        ).toLocaleDateString("en-GB", {
                          day: "2-digit",
                          month: "short",
                          year: "numeric",
                        })
                      : ""
                  }
                />
              </Form.Group>

              {/* Reasons */}
              <Form.Group className="mb-2">
                <Form.Label>Reasons</Form.Label>
                <Form.Control
                  name="reasons"
                  value={form.reasons}
                  onChange={this.handleChange}
                />
              </Form.Group>

              {/* Leave Type */}
              <Form.Group className="mb-2">
                <Form.Label>Leave Type</Form.Label>
                <Form.Select
                  name="leaveType"
                  value={form.leaveType}
                  onChange={this.handleChange}
                >
                  <option value={1}>Sick Leave</option>
                  <option value={2}>Personal Leave</option>
                </Form.Select>
              </Form.Group>
            </Form>
          </Modal.Body>

          <Modal.Footer>
            <Button
              variant="primary"
              onClick={this.saveAbsence}
              disabled={!form.employeeId || !form.startDate}
            >
              Save
            </Button>
            <Button variant="secondary" onClick={this.closeModal}>
              Cancel
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
